import React, { useContext } from 'react';
import { GlobalContext } from "../../common/context";
import Products from "../../common/screens/products";
import Cart from "../flow1/cart";
import Payment from "../flow1/payment";

const Flow1App = () => {
  const { step, initialLoading } = useContext(GlobalContext);
  return (
    <>
      { step === 'products' && <Products initialLoading={ initialLoading } /> }
      { step === 'cart' && <Cart /> }
      { step === 'payment' && <Payment /> }
    </>
  );
};

export default Flow1App;
